/**
 * * Элемент списка уровней слоэности
 */
export default class GetDifficultyListItem  {
	/**
	 * * Номер
	 */
	Id!: string;
	/**
	 * * Идентификатор рабочей области
	 */
	NamespaceId!: string;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Цвет
	 */
	Color!: string;
	/**
	 * * Главный уровень сложности (не возможно исключить)
	 */
	IsMain: boolean = false;
	/**
	 * * Используется по умолчанию
	 */
	IsDefault: boolean = false;
	/**
	 * * Используется задачами
	 */
	InUse: boolean = false;
	constructor(obj?: Partial<GetDifficultyListItem>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
